import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { uploadExcelFile } from "../../../services/Societe";
import makeAnimated from "react-select/animated";
import { useLocation } from 'react-router-dom';
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import api from "../../../services/api";
import { ToastContainer, toast } from "react-toastify";
import withLoader from "../../../components/layouts/WithLoader";
const UploadEmployeExcel = ({ startLoading, stopLoading }) => {
  const [uploadedData, setUploadedData] = useState(null); // Track file
  const [isUploading, setIsUploading] = useState(false); // Track upload state
  const [warehouseSourceId, setWarehouseSourceId] = useState(null);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);


  // Function to download the model Excel
  const onTelechargerModel = () => {
    const headers = [
      ["MLE", "NOMS", "PRENOMS", "GENRE h/f", "N°CIN", "QUALIFICATION", "DATE NAISSANCE", "N° CNSS", "SIT.FAMI", "N° ENFANT", "AFFECTATION", "S.BASE", "VILLE", "CODE POSTAL"], // Header row
      // ["5505631", "RESPONSABLE ACHAT", "28/10/1970", "1220424806", "M", "3", "ADMINISTRATION", "2072.283", "SOUSSE", "4054"],   // Example row of data
    ];
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet(headers);

    // Add green background styling to headers
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!worksheet[cellAddress]) continue;
      worksheet[cellAddress].s = {
        fill: { fgColor: { rgb: "00FF00" } }, // Green background
        font: { bold: true, color: { rgb: "000000" } }, // Black bold text
      };
    }

    // Append worksheet to workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Model");

    // Save file as a downloadable Excel file
    const fileBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([fileBuffer], { type: "application/octet-stream" }), "model.xlsx");
  };

  // Handle file upload
  const handleFileUpload = (e) => {
    const file = e.target.files[0]; // Get the first file from the input
    if (file) {
      setUploadedData(file); // Store the file in state
    }
  };
  // Upload the Excel file to the server
  const uploadExcelFileToServer = (file) => {
    if (!file) {
      toast.error("Aucun fichier sélectionné");
      return Promise.reject(new Error("No file provided"));
    }
    startLoading()
    const formData = new FormData();
    formData.append("file", file);

    const url = `/rh/employees/addEmployeExcel/${getCurrentUserId()}`;

    return api
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      })
      .then((response) => {
        toast.success("Fichier téléchargé avec succès");
        stopLoading();
        return response;
      })
      .catch((error) => {
        toast.error("Erreur lors du téléchargement du fichier");
        stopLoading();
        throw error;
      });
  };

  const handleAjouter = () => {
    if (uploadedData && !isUploading) {
      setIsUploading(true); // Set uploading state to true
      uploadExcelFileToServer(uploadedData)
        .then((response) => {
          console.log("Upload successful", response);
        })
        .catch((error) => {
          console.error("Upload error", error);
        })
        .finally(() => {
          setIsUploading(false); // Reset uploading state after process finishes
        });
    } else {
      console.error("No file selected for upload or upload already in progress.");
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToastContainer />
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Home</li>
                <li className="breadcrumb-item active">Ajouter Personnel</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-footer">
                  <h3>Ajouter la liste du personnel</h3>
                </div>
                <div className="p-3 d-flex justify-content-between align-items-center">
                  <h4>Télécharger le Model Excel</h4>
                  <button className="btn btn-dark float-right" onClick={onTelechargerModel}>
                    <i className="fas fa-download"></i> Télécharger model Excel
                  </button>
                </div>
                <div className="card-body">
                  <p>Si la valeur de la colonne n'est pas présente merci de mettre -</p>
                </div>
                <div className="p-3 d-flex justify-content-between align-items-center">
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    className="btn btn-dark float-right"
                    onChange={handleFileUpload} // Handle file selection
                  />
                  <button
                    className="btn btn-dark float-end"
                    onClick={handleAjouter} // Upload file
                    title="Ajouter cette liste"
                    aria-label="Ajouter cette liste"
                    disabled={isUploading} // Disable button while uploading
                  >
                    <i className="fas fa-location-arrow" aria-hidden="true"></i> Ajouter cette liste
                  </button>
                </div>
                <div className="card-footer"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(UploadEmployeExcel);
